import { axios } from '@Root/API'

export const edit = (entity, entityType, payload) => {
	return axios.post(`table-manager/columns/entity/${entity}/entity-type/${entityType}`, payload)
}
